/** @format */

import {Customized, Line, ResponsiveContainer, ComposedChart} from 'recharts';

import {XAxisRoot as Root} from './style';
import {XAxisDataList} from '../../model/xAxis';
import {CommonChartData} from '../../model/charts';
import {TodayMarker} from './TodayMarker';
import {MarginOptions} from '../../model/common';

interface Props {
  xAxisDataList: XAxisDataList;
  chart?: CommonChartData[];
  syncId?: string;
  height: number;
  margin: MarginOptions;
}

const XAxisWithTodayMarker = ({syncId, xAxisDataList, chart, height, margin}: Props) => {
  return (
    <Root height={height}>
      <ResponsiveContainer>
        <ComposedChart data={chart} syncId={syncId} margin={margin}>
          <Line dataKey='amount' strokeWidth={0} animationDuration={0} dot={false} />

          <Customized
            component={<TodayMarker xAxisDataList={xAxisDataList} lineHeight={height} />}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Root>
  );
};

export default XAxisWithTodayMarker;
